export const ATTACHMENT_STATUSES = Object.freeze({
  approved: 'approved',
  pendingUpload: 'pending_upload',
  pending: 'pending',
  rejected: 'rejected',
  expired: 'expired',
  notApplicable: 'not_applicable',
})
